import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { LeaderboardService, LocalService } from 'src/app/core';

@Component({
  selector: 'leaderboard-detail-drawer',
  templateUrl: './leaderboard-detail-drawer.component.html',
  styleUrls: ['./leaderboard-detail-drawer.component.scss']
})
export class LeaderboardDetailDrawerComponent implements OnChanges {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  close() {
    this.closed.emit();
  }
  leaderboardRankDetails: any;
  isLoadingProgress = false;

  rankingsData: any[] = [];
  rankingsTotalElements: number = 0;
  rankingsLoading: boolean = false;
  userBeGeoId: any = null;

  constructor(private leaderboardService: LeaderboardService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      if (this.challenge && this.challenge.userLeaderboardChallengeId) {
        this.getSpecificLeaderboardData(this.challenge.userLeaderboardChallengeId);
      }
      this.loadRankings();
    }
  }

  loadRankings() {
    if (!this.challenge || !this.challenge.id) { return; }
    const userProfile = LocalService.get('userProfile');
    const companyId = userProfile && userProfile.company ? userProfile.company.id : null;
    this.userBeGeoId = userProfile && userProfile.company ? userProfile.company.beGeoId : null;
    const req = this.challenge.id + '?companyId=' + companyId + '&page=0&size=10';
    this.rankingsLoading = true;
    this.rankingsData = [];
    this.rankingsTotalElements = 0;
    this.leaderboardService.getLeaderboardChallengeData(req).subscribe(
      (res: any) => {
        this.rankingsData = (res && res.content) ? res.content : [];
        this.rankingsTotalElements = (res && res.totalElements) ? res.totalElements : 0;
        this.rankingsLoading = false;
      },
      () => { this.rankingsLoading = false; }
    );
  }

  formatDate(date: string): string {
    const monthIndex = Number(date.substring(5, 7).replace(/^0+/, '')) - 1;
    const day = date.substring(8, 10).replace(/^0+/, '');
    const year = date.substring(0, 4);
    return `${this.months[monthIndex]} ${day}, ${year}`;
  }

  getStatusBadgeColor(status: string): string {
    switch (status) {
      case 'ACTIVE': return 'border-green-500 text-green-600 bg-green-50';
      case 'INACTIVE': return 'border-gray-400 text-gray-600 bg-gray-50';
      case 'READY_TO_LAUNCH': return 'border-blue-500 text-blue-600 bg-blue-50';
      default: return 'border-gray-400 text-gray-600 bg-gray-50';
    }
  }

  getStatusText(status: string): string {
    switch (status) {
      case 'READY_TO_LAUNCH': return 'Ready to Launch';
      default: return status || 'N/A';
    }
  }
  getSpecificLeaderboardData(id: any) {
    this.isLoadingProgress = true;
    this.leaderboardRankDetails = null;
    this.leaderboardService.getLeaderboardRankDetails(id).subscribe(
      (response) => {
        this.leaderboardRankDetails = response;
        this.isLoadingProgress = false;
      },
      (err) => {
        console.error('[getSpecificLeaderboardData] ERROR:', err);
        this.isLoadingProgress = false;
      }
    );
  }

}
